export default {"src":"https://fishbrain.com/_next/static/media/maryland.d8c691ac.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};